import _Symbol from "@babel/runtime-corejs3/core-js/symbol";
var MATCHES = {
  NOT_SURE: _Symbol('MATCHES.NOT_SURE'),
  YES: _Symbol('MATCHES.YES'),
  NO: _Symbol('MATCHES.NO')
};
export default MATCHES;